<template>
	<!-- <section class="bg-white dark:bg-gray-900">
   <div class="gap-8 items-center py-8 px-4 mx-auto max-w-screen-xl xl:gap-16 md:grid md:grid-cols-2 sm:py-16 lg:px-6">
	   <img class="w-full dark:hidden" src="../assets/crbnWL.svg" alt="dashboard image">
	   <img class="w-full hidden dark:block" src="https://flowbite.s3.amazonaws.com/blocks/marketing-ui/cta/cta-dashboard-mockup-dark.svg" alt="dashboard image">
	   <div class="mt-4 md:mt-0">
		   <h2 class="mb-4 text-4xl tracking-tight font-extrabold text-gray-900 dark:text-white">Let's create more tools and ideas that brings us together.</h2>
		   <p class="mb-6 font-light text-gray-500 md:text-lg dark:text-gray-400">Flowbite helps you connect with friends and communities of people who share your interests. Connecting with your friends and family as well as discovering new ones is easy with features like Groups.</p>
		   <a href="#" class="inline-flex items-center text-white bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:focus:ring-primary-900">
			   Get started
			   <svg class="ml-2 -mr-1 w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
		   </a>
	   </div>
   </div>
   </section> -->
   <section class="bg-white dark:bg-gray-900">
 <div class="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6 ">
	 <div class="mx-auto max-w-screen-sm text-center mb-8 lg:mb-16">
		 <h2 class="mb-4 text-4xl tracking-tight font-extrabold text-gray-900 dark:text-white">Sponsors & Partnerships</h2>
		 <p class="font-light text-gray-500 lg:mb-16 sm:text-xl dark:text-gray-400">Explore the brands I currently use</p>
	 </div> 

	 
	 

	 <div class="grid gap-8 mb-6 lg:mb-16 md:grid-cols-2">

		<div class="items-center bg-gray-50 rounded-lg shadow sm:flex dark:bg-gray-800 dark:border-gray-700">
			 <a href="#">
				 <img class="w-full rounded-lg sm:rounded-none sm:rounded-l-lg transition-all duration-300 cursor-pointer filter grayscale-0 hover:grayscale" src="../assets/lifetime/LifetimeLogoGB.svg" alt="Jese Avatar">
			 </a>
			 <div class="p-5">
				 <h3 class="text-xl font-bold tracking-tight text-gray-900 dark:text-white">
					 <a href="#">Life Time Fitness</a>
				 </h3>
				 <span class="text-gray-500 dark:text-gray-400"></span>
				 <p class="mt-3 mb-4 font-light text-gray-500 dark:text-gray-400">Healthy People, Healthy Planet, Healthy Way of Life</p>   
				 <a rel="noopener noreferrer" target="_blank" href="https://www.lifetime.life/locations/ca/laguna-niguel.html" class="inline-flex items-center  font-bold text-walter-primary hover:text-walter-secondry">
					Laguna Niguel Gym
				   <svg class="ml-1 w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"></path></svg>
				 </a>				                
			 </div>
		 </div> 




		 <div class="items-center bg-gray-50 rounded-lg shadow sm:flex dark:bg-gray-800 dark:border-gray-700">
			 <a href="https://crbnpickleball.com/" target="_blank">
				 <img class="w-full rounded-lg sm:rounded-none sm:rounded-l-lg transition-all duration-300 cursor-pointer filter grayscale-0 hover:grayscale" src="../assets/sponsor/crbndarkWL.svg" alt="Bonnie Avatar">
			 </a>
			 <div class="p-5">
				 <h3 class="text-xl font-bold tracking-tight text-gray-900 dark:text-white">
					 <a href="#">CRBN</a>
				 </h3>
				 <span class="text-gray-500 dark:text-gray-400">Pickleball</span>                  
			   <p class="mt-3 mb-4 font-light text-gray-500 dark:text-gray-400">Live to Play, with some of the best paddles on the market. Use Code WalterCRBN10 for 10% off!</p> 
			   <a href="https://crbnpickleball.com/" target="_blank" class="inline-flex items-center font-medium text-walter-primary hover:text-walter-secondry dark:text-primary-500 dark:hover:text-primary-700">
				   CRBN Store
			   <svg class="ml-1 w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"></path></svg>
			   </a>                                
			 </div>			 
		 </div> 


		 <div class="items-center bg-gray-50 rounded-lg shadow sm:flex dark:bg-gray-800 dark:border-gray-700">
			 <a href="http://www.rudystacoshop.com/" target="_blank">
				 <img class="w-full rounded-lg sm:rounded-none sm:rounded-l-lg transition-all duration-300 cursor-pointer filter grayscale-0 hover:grayscale" src="../assets/sponsor/rudyLogo.jpeg" alt="Michael Avatar">
			 </a>
			 <div class="p-5">
				 <h3 class="text-xl font-bold tracking-tight text-gray-900 dark:text-white">
					 <a href="#">Rudy's</a>
				 </h3>
				 <span class="text-gray-500 dark:text-gray-400"></span>
				 <p class="mt-3 mb-4 font-light text-gray-500 dark:text-gray-400">Authentic Mexican Food in San Diego. </p>
				 <p class="mt-3 mb-4 font-light text-gray-500 dark:text-gray-400">"Friend of Walter Discount" gives you 20% off your order!</p>
				 <a href="http://www.rudystacoshop.com/" target="_blank" class="inline-flex items-center font-medium text-walter-primary hover:text-walter-secondry dark:text-primary-500 dark:hover:text-primary-700">
						 Website
					 <svg class="ml-1 w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"></path></svg>
					 </a>                                                
			 </div>
		 </div> 

		 <div class="items-center bg-gray-50 rounded-lg shadow sm:flex dark:bg-gray-800 dark:border-gray-700">
			 <a href="#">
				 <img class="w-full rounded-lg sm:rounded-none sm:rounded-l-lg transition-all duration-300 cursor-pointer filter grayscale-0 hover:grayscale" src="../assets/sponsor/paddlewrap2.jpg" alt="Jese Avatar">
			 </a>
			 <div class="p-5">
				 <h3 class="text-xl font-bold tracking-tight text-gray-900 dark:text-white">
					 <a href="#">MYPADL</a>
				 </h3>
				 <span class="text-gray-500 dark:text-gray-400"></span>
				 <p class="mt-3 mb-4 font-light text-gray-500 dark:text-gray-400">Personalize your Paddle and Gear.</p>   
				 <a rel="noopener noreferrer" target="_blank" href="http://mypadl.com/Walter" class="inline-flex items-center  font-bold text-walter-primary hover:text-walter-secondry">Mypadl Link
				   <svg class="ml-1 w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"></path></svg>
				 </a>				                
			 </div>
		 </div> 		 
		 
	 </div>  
 </div>
</section>
   
</template>



<script>
import { initTooltips, initDropdowns  } from "flowbite"
import {onMounted, ref} from 'vue'


export default {
   setup(){
	   const dropDowner = ref(['mario', 'lugio', 'peach'])
	   const memberTest = ref([
		   {id: 1, first: 'billy', last: 'gaonzo', email: 'ger@gmail.com'},            
		   {id: 2, first: 'bozo', last: 'sfeged', email: 'gdfeer@gmail.com'}
	   ])
	   
	   const keymaster = Object.keys(memberTest.value[0])
	   onMounted(() => {
		   // const script = document.createElement('script');
		   // script.src = 'https://assets.calendly.com/assets/external/widget.js';
		   // script.async = true;
		   // document.head.appendChild(script);
	   });
	   

	   // onMounted(()=>{ initTooltips(), initDropdowns();})

	   return {dropDowner, memberTest}
   }    
}
</script>

<style>

</style>